import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { provideMasters } from 'src/composables/useMasters';
import { useAuth } from 'src/composables/useAuth';


export default /*@__PURE__*/_defineComponent({
  __name: 'MasterProvider',
  setup(__props) {

const auth = useAuth();

// AuthProvider が user を確定（isUserEnsured）してから本コンポーネントが描画されるため、
// 非ゲストページでは setup 時点で user が存在する。ゲストページでは user が無くマスターは不要。
if (auth.user) {
  provideMasters(auth.user);
}

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})